import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import getComliancy from "../services/compliancyService";

function FormsTrackingClientProgram({ clientProgram, history, filteredForm }) {
  const [showRules, setShowRules] = useState(false);
  const compliancyConfig = clientProgram.unit.sor_compliancy
    ? JSON.parse(clientProgram.unit.sor_compliancy).compliancy
    : [];
  const compliancy = getComliancy(compliancyConfig, clientProgram, history);
  console.log("history compliancy", compliancy);

  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("safyInfo")).user;

  const statusColor = (status, dueDate, window) => {
    switch (status) {
      case "Not Done":
        if (moment().isBefore(moment(dueDate).subtract(window, "days"))) {
          return "row text-dark";
        } else {
          return "row bg-warning ";
        }
      case "Past Due":
        return "row bg-danger text-white";
      case "Late":
        return "row bg-warning ";
      default:
        return "row text-dark";
    }
  };
  return (
    <div className="rounded border bg-safy2-4 p-2 m-2">
      <div className="h5">
        <Link
          id={clientProgram.ccx_patient["#text"].replace(/[{}]/g, "")}
          title="Open Client Record"
          to={`/client/${clientProgram.ccx_patient["#text"].replace(
            /[{}]/g,
            ""
          )}`}
          state={{
            previousPath: location.pathname,
          }}
        >
          <div className="btn btn-primary fw-bold">
            {clientProgram.ccx_patient["@name"]}
          </div>
        </Link>
      </div>
      <div className="row fw-bold ps-4">
        <div className="col">
          {clientProgram.ccx_name}
          <i
            className="fas fa-info-circle text-primary mb-2 ms-2"
            title="Show Compliancy Rules"
            onClick={() => setShowRules(!showRules)}
          />
        </div>
        <div className="col">{`Admit: ${clientProgram.ccx_admitdate["@date"]}`}</div>
        <div className="col text-danger">
          {clientProgram.ccx_dischargedate
            ? `Discharge: ${clientProgram.ccx_dischargedate["@date"]}`
            : null}
        </div>
      </div>
      <div>
        {Object.values(compliancy).map((c) => {
          if (
            (filteredForm && c.formId !== filteredForm) ||
            (c.name !== "TFC Outcomes Form" && c.name !== "SC TFC Outcomes")
          )
            return null;
          return (
            <div
              key={`${clientProgram["ccx_client_programid"]}-${c.formId}`}
              className="border rounded bg-light p-3 mb-1"
            >
              <div className="row">
                <div className="col-10 h5 fw-bold">
                  {c.name}
                  {new Date(c.implemented) >
                  new Date(clientProgram.ccx_admitdate["@date"]) ? (
                    <i
                      className="fas fa-asterisk fa-xs text-danger ms-2"
                      title="Form Implemented After Admission"
                      onClick={() =>
                        toast.warning("Form Implemented After Client Admission")
                      }
                    />
                  ) : null}
                </div>
                <div className="col-2">
                  <Link
                    title={`Add ${c.name}`}
                    className=" text-primary"
                    style={{ textDecoration: "none" }}
                    to={`../${c.path}${
                      c.path !== "form" &&
                      c.formVersion !== undefined &&
                      c.versionNumber !== "1"
                        ? `v${c.versionNumber}`
                        : ""
                    }/${c.formVersion}/${clientProgram.con.contactid.replace(
                      /[{}]/g,
                      ""
                    )}`}
                    state={{
                      client: clientProgram.ccx_patient,
                      clientProgram: {
                        "#text": clientProgram.ccx_client_programid,
                        "@name": clientProgram.ccx_name,
                      },
                      SubmissionId: "",
                      initialData: {},
                      comments: "",
                      createdBy: {
                        "#text": user.safyInfo.SystemUserId,
                        "@name": user.displayName,
                      },
                      tab: "forms",
                      previousPath: location.pathname,
                      selectedProgram: clientProgram,
                    }}
                  >
                    <i className="fas fa-plus-circle fa-xl float-end text-primary mt-2 "></i>
                  </Link>
                </div>
              </div>
              {showRules ? (
                <>
                  <div className="row mx-2 text-danger">
                    {`Initial Due: ${c.rules.initial.days} days after ${c.rules.initial.event}`}
                  </div>
                  <div className="row mx-2 text-danger">
                    {`Subsequent Due: ${c.rules.subsequent.days} days after ${c.rules.subsequent.event}`}
                  </div>
                  {c.rules.discharge ? (
                    <div className="row mx-2 text-danger">
                      {`Discharge Due: ${c.rules.discharge.days} days after ${c.rules.discharge.event}`}
                    </div>
                  ) : null}
                  <div className="row mx-2 text-danger">
                    {`Implemented: ${c.rules.implemented} `}
                  </div>
                </>
              ) : null}
              <div className="row fw-bold">
                <div className="col-3">Due</div>
                <div className="col-3">Final Signed</div>
                <div className="col-2">Span</div>
                <div className="col-3">Status</div>
                <div className="col-1"></div>
              </div>
              {c.history &&
                c.history.map((h, index) => (
                  <div
                    key={`${clientProgram["ccx_client_programid"]}-${c.formId}-${index}`}
                    className={statusColor(h.compliant, h.dueDate, h.window)}
                  >
                    <div className="col-3">{h.dueString}</div>
                    <div className="col-3">{h.dateSigned}</div>
                    <div className="col-2">
                      {h.days ||
                        `Due In ${moment(h.dueDate).diff(
                          moment(),
                          "days"
                        )} days`}
                    </div>

                    <div className="col-3">{h.compliant}</div>
                    <div className="col-1">
                      {h.submissionId ? (
                        <Link
                          title={`Open ${c.name}`}
                          className=" text-primary"
                          style={{ textDecoration: "none" }}
                          to={`../${c.path}${
                            c.path !== "form" &&
                            c.formVersion !== undefined &&
                            c.formVersion !== "1"
                              ? `v${c.formVersion}`
                              : ""
                          }/${
                            c.formVersion
                          }/${clientProgram.con.contactid.replace(
                            /[{}]/g,
                            ""
                          )}/${h.submissionId}`}
                          state={{
                            client: clientProgram.ccx_patient,
                            clientProgram: {
                              "#text": clientProgram.ccx_client_programid,
                              "@name": clientProgram.ccx_name,
                            },
                            SubmissionId: "",
                            initialData: {},
                            comments: "",
                            createdBy: {
                              "#text": user.safyInfo.SystemUserId,
                              "@name": user.displayName,
                            },
                            tab: "forms",
                            previousPath: location.pathname,
                            selectedProgram: clientProgram,
                          }}
                        >
                          <i className="fas fa-arrow-right" role="button"></i>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FormsTrackingClientProgram;
